import { render, staticRenderFns } from "./ProjectInformationProjectComponent.vue?vue&type=template&id=31d8f4b0"
import script from "./ProjectInformationProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectInformationProjectComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectInformationProjectComponent.vue?vue&type=style&index=0&id=31d8f4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports